module.exports = __webpack_public_path__ + "media/newstyle/images/icon-book-grey-5d05f6279371de6896fcbe12ee1ce0cf.svg";